import React from 'react';
import cn from 'classnames';
import { Typography } from '../../../Typography';
import "./styles.css";
export var TooltipContent = function (_a) {
    var title = _a.title, className = _a.className;
    return (React.createElement("div", { className: cn('lk-ui_tooltip', className) },
        React.createElement(Typography, { variant: 'caption', className: 'lk-ui_tooltip-title' }, title)));
};
